import { Link } from 'react-router-dom';

export default function Unauthorized() {
  return (
    <div className="wb-login-wrap wb-unauthorized">
      <div className="wb-auth-panel">
        <span className="wb-auth-mark">WorkBill</span>
        <h1>Access not approved</h1>
        <p>Your Google account is signed in, but it is not listed in the WorkBill admin allowlist.</p>
        <Link className="wb-button-link" to="/login">Back to sign in</Link>
      </div>
    </div>
  );
}
